import http from '../request';

export const dictlist = (params: IDictParams): RES<IDictModel> => http.post("/system/dict/data/list1", params,{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
)

export const dictget = (): RES<IDictModel> => http.get("/system/dict/data/get")
